/**
 * Apple-style keyboard shortcuts (⌘). Uses `navigator.platform`, matching ag-grid's `_isMacOsUserAgent`.
 * (Lifted from ag-grid's similar mechanism.)
 */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}
